import React from 'react'

import isEmpty from 'utils/toolset/isEmpty'
import pluralize from 'utils/toolset/pluralize'

import { Stack } from 'components/Layout'
import { Text } from 'components/Text'

import { useDragDropFileContext } from '../DragDropFile.context'

import type { FileListProps } from '../types'
import { FileListUL } from '../styles'

import FileItem from './FileItem'

const FileList = ({ disabled, ...props }: FileListProps): JSX.Element | null => {
  const { fileList, onRemoveFile, onRetryUpload } = useDragDropFileContext()

  if (isEmpty(fileList)) {
    return null
  }

  const uploadedFiles = fileList.filter((file) => file.status === 'success').length

  return (
    <Stack space="m" {...props}>
      <Text variant="heading-sm-bold">{`${uploadedFiles} ${pluralize(
        uploadedFiles,
        'Files',
        'File'
      )} uploaded`}</Text>
      <FileListUL space="m">
        {fileList.map((item, index) => (
          <FileItem
            key={`file-${item.file.name}-${index}`}
            disabled={disabled}
            onRemove={() => onRemoveFile(item, index)}
            onRetry={onRetryUpload ? () => onRetryUpload(item, index) : undefined}
            {...item}
          />
        ))}
      </FileListUL>
    </Stack>
  )
}

export default FileList
